@if (loading) {
  <div class="flex flex-row justify-between items-start w-full h-full overflow-x-auto overflow-y-hidden gap-4">
    @for (skeleton of [1, 2, 3, 4]; track skeleton) {
      <div class="h-full w-[24%] min-w-[320px] flex-1 flex flex-col animate-pulse">
        <div class="flex flex-row items-center gap-2 mb-4 p-4 bg-gray-100 rounded-xl">
          <div class="h-5 w-5 bg-gray-200 rounded-full"></div>
          <div class="h-5 bg-gray-200 rounded-full w-24"></div>
          <div class="h-5 bg-gray-200 rounded-full w-8 ml-1"></div>
        </div>
        <div class="flex flex-col gap-4 pt-4">
          @for (card of [1, 2, 3]; track card) {
            <div class="flex flex-col gap-2 p-3 bg-white rounded-lg border border-gray-200">
              <div class="h-4 bg-gray-200 rounded-full w-3/4"></div>
              <div class="h-3 bg-gray-200 rounded-full w-1/2"></div>
              <div class="flex flex-row gap-2 mt-1">
                <div class="h-3 bg-gray-200 rounded-full w-16"></div>
                <div class="h-3 bg-gray-200 rounded-full w-12"></div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
} @else if (hasAnyTasks() && hasAnyFilteredTasks()) {
  <div cdkDropListGroup class="flex flex-col justify-start items-start w-full h-full gap-4">
    <!--  <div class="flex flex-row justify-start gap-2 items-start">-->
    <!--    <button mat-raised-button  (click)="createNewTask()">Aufgabe erstellen</button>-->
    <!--    <button mat-raised-button  (click)="importBCFClicked.emit()">BCF importieren</button>-->
    <!--    <button mat-raised-button [disabled]="selectedTasks.length==0"  (click)="exportBCFsClicked.emit(selectedTasks)">BCF exportieren</button>-->
    <!--  </div>-->
    <div class="flex flex-row justify-between items-start w-full h-full overflow-x-auto overflow-y-hidden gap-4">
      @for (state of stateEnum | keyvalue: keepOrder; track state) {
        <div (cdkDropListDropped)="!selectionMode && permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT') && drop($event)"
             [cdkDropListData]="taskStateFrom(tasks.get(state.key)!, state.value)"
             cdkDropList
             class="h-full w-[24%] min-w-[320px] flex-1 flex flex-col">
          <div class="flex flex-col w-full gap-2.5 p-4 bg-gray-100 rounded-xl">
            <div class="flex flex-row items-center gap-2 min-w-0 w-full">
              @if (state.value === 'OPEN') {
                <fa-icon [icon]="faMoonFull" class="text-base text-gray flex-shrink-0"></fa-icon>
              }
              @if (state.value === 'PROCESS') {
                <fa-icon [icon]="faCircleHalfStroke" class="text-base -rotate-90 text-gray flex-shrink-0"></fa-icon>
              }
              @if (state.value === 'DONE') {
                <fa-icon [icon]="faCircle" class="text-base text-gray flex-shrink-0"></fa-icon>
              }
              @if (state.value === 'VERIFIED') {
                <fa-icon [icon]="faCircleCheck" class="text-base text-gray flex-shrink-0"></fa-icon>
              }
              <h2 class="font-medium text-base text-gray truncate min-w-0">{{ state.value | taskState }}</h2>
              <span class="font-medium text-base text-gray flex-shrink-0">({{ taskCount(state.value) }})</span>
              @if (stateConfigService.getProjectId() > 0 && !selectionMode) {
                @if (permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT')) {
                  <fa-icon (click)="createNewTask(state.value)" [icon]="faPlus"
                           class="flex-shrink-0 cursor-pointer ml-auto"></fa-icon>
                } @else {
                  <div [tooltip]="'Keine Berechtigung'" class="ml-auto cursor-not-allowed">
                    <fa-icon [icon]="faPlus" class="flex-shrink-0 text-gray-300"></fa-icon>
                  </div>
                }
              }
            </div>
            @if (stateConfigService.getProjectId() > 0) {
              @if (selectionMode) {
                <div
                  (click)="areAllColumnTasksSelected(state) ? deselectColumnTasks(state) : selectColumnTasks(state)"
                  [class]="areAllColumnTasksSelected(state) ? 'bg-white' : 'bg-gray-100'"
                  class="flex flex-row w-full rounded-lg border-dashed border border-gray-300 px-5 py-4 items-center justify-center  text-gray-500 gap-2 hover:cursor-pointer">
                  <!--            <input *ngIf="selectionMode" type="checkbox" [checked]="areAllColumnTasksSelected(state)" #checkbox class="w-4 h-4 rounded text-green-600 checked:bg-green indeterminate:bg-green indeterminate:hover:bg-green focus:ring-[none] bg-gray-100 border-gray-300">-->
                  @if (areAllColumnTasksSelected(state)) {
                    <span>Alle abwählen</span>
                  }
                  @if (!areAllColumnTasksSelected(state)) {
                    <span>Alle auswählen</span>
                  }
                </div>
              }
            }
          </div>
          <div class="flex flex-col gap-4 h-full overflow-y-auto pt-4">
            <!--          <div class="flex flex-col w-full p-5">-->
            <!--            <div class="flex flex-row w-full pb-2 justify-between items-center border-b border-gray-200">-->
            <!--              <span>Neue Task erstellen</span>-->
            <!--              <fa-icon [icon]="faX"></fa-icon>-->
            <!--            </div>-->
            <!--            <div [formGroup]="newTaskForm">-->
            <!--              <div formGroupName="markup">-->
            <!--                <div formGroupName="topic">-->
            <!--&lt;!&ndash;                  <bic-input formControlName="title" [label]="'Name'" [placeholder]="'Name hinzufügen * (erforderlich)'"></bic-input>&ndash;&gt;-->
            <!--&lt;!&ndash;                  <bic-input bicDatepickerInput formControlName="dueDate" [label]="'Fällig am'" [placeholder]="'27/08/2023'"></bic-input>&ndash;&gt;-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--          </div>-->
            @for (task of filteredTasks.get(state.value); track task.id ?? task) {
              <div [cdkDragData]="task" cdkDrag
                   [cdkDragDisabled]="!permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT')">
                <app-task-card (click)="selectTask(task)" (exportBCFClicked)="exportBCFClicked.emit($event)"
                               [selected]="isTaskSelected(task)" [selectionMode]="selectionMode"
                               (duplicateTask)="onTaskDuplicated($event)"
                               [task]="task"></app-task-card>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
} @else if (hasAnyTasks() && hasActiveSearchOrFilter()) {
  <app-empty-state [icon]="faCircleInfo" message="Keine Aufgaben gefunden">
    @if (showResetSearchButton()) {
      <bic-button (onClick)="onResetSearch()" buttonType="white">Suche zurücksetzen</bic-button>
    }
  </app-empty-state>
} @else {
  <app-empty-state [icon]="faCircleInfo" message="Noch keine Tasks erstellt">
    @if (permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT')) {
      <bic-button (onClick)="createNewTask()" buttonType="white">
        Task erstellen
        <fa-icon [icon]="faClipboardCheck" iconLeft></fa-icon>
      </bic-button>
    } @else {
      <div [tooltip]="'Keine Berechtigung'" class="ml-auto cursor-not-allowed">
        <bic-button [disabled]="true" buttonType="white">
          Task erstellen
          <fa-icon [icon]="faClipboardCheck" iconLeft></fa-icon>
        </bic-button>
      </div>
    }
  </app-empty-state>
}
